export default "__VITE_ASSET__CS71hdYY__"